import { createWorkerAction } from '../../lib';

export const logout = createWorkerAction('LOGOUT');
